<template>
    <aside :class="`${is_expanded ? 'is-expanded' : ''}`">
        <router-link to="/" v-if="is_expanded">
            <div class="logo">
                <img src="@/assets/logo-fundo.png" alt="Vue" />
            </div>
        </router-link>

        <div class="menu-toggle-wrap">
            <button class="menu-toggle" @click="ToggleMenu">

                <span class="material-icons">
                    <b-icon icon="list" aria-hidden="true"></b-icon>
                </span>
            </button>
        </div>

        <h3>Menu</h3>
        <div class="menu">
            <router-link to="/familias" class="button">
                <span class="material-icons">
                    <b-icon icon="folder-fill" aria-hidden="true"></b-icon>
                </span>
                <span class="text">{{ $t("menu.familias") }}</span>
            </router-link>
            <router-link to="/analise-linhas" class="button">
                <span class="material-icons">
                    <b-icon icon="stoplights-fill" aria-hidden="true"></b-icon>
                </span>
                <span class="text">{{ $t("menu.analise-linhas") }}</span>
            </router-link>
            <router-link to="/apresentacoes" class="button">
                <span class="material-icons">
                    <b-icon icon="collection-play-fill" aria-hidden="true"></b-icon>
                </span>
                <span class="text">{{ $t("menu.apresentacoes") }}</span>
            </router-link>
            <router-link to="/trend" class="button">
                <span class="material-icons">
                    <b-icon icon="graph-up" aria-hidden="true"></b-icon>
                </span>
                <span class="text">{{ $t("menu.trend") }}</span>
            </router-link>
            <router-link to="/usuarios" class="button" v-if="user.permissao =='acesso_total' ">
                <span class="material-icons">
                    <b-icon icon="people-fill" aria-hidden="true"></b-icon>
                </span>
                <span class="text">{{ $t("menu.usuarios") }}</span>
            </router-link>
            <router-link to="/departamentos" class="button" v-if="user.permissao =='acesso_total' ">
                <span class="material-icons">
                    <b-icon icon="diagram3-fill" aria-hidden="true"></b-icon>
                </span>
                <span class="text">{{ $t("menu.departamentos") }}</span>
            </router-link>
            <router-link to="/turnos" class="button" v-if="user.permissao =='acesso_total' ">
                <span class="material-icons">
                    <b-icon icon="clock-fill" aria-hidden="true"></b-icon>
                </span>
                <span class="text">{{ $t("menu.turnos") }}</span>
            </router-link>
            <router-link to="/linhas" class="button" v-if="user.permissao =='acesso_total' ">
                <span class="material-icons">
                    <b-icon icon="hdd-network-fill" aria-hidden="true"></b-icon>
                </span>
                <span class="text">{{ $t("menu.linhas") }}</span>
            </router-link>
            <router-link to="/atualizar-controles" target="_blank" class="button" v-if="user.permissao =='acesso_total' ">
                <span class="material-icons">
                    <b-icon icon="arrow-clockwise" aria-hidden="true"></b-icon>
                </span>
                <span class="text">{{ $t("menu.atualizar-controles") }}</span>
            </router-link>
        </div>

        <div class="flex"></div>

        <div class="menu">
            <div v-b-modal.config-geral class="button" v-if="user.permissao =='acesso_total' ">
                <span class="material-icons">
                    <b-icon icon="gear-fill" aria-hidden="true"></b-icon>
                </span>
                <span class="text">{{ $t("menu.configuracoes") }}</span>
            </div>
        </div>

    </aside>
</template>

<script>


export default {
    components: {
    },
    data() {
        return {
            baseUrl: window.location.origin + process.env.VUE_APP_ROOT
        }
    },
    computed: {
        user() {
            return this.$store.state.auth.user.user;
        },
        is_expanded: {
            get() {
                return this.$store.state.is_expanded;
            },
            set(value) {
                this.$store.commit("setExpanded", value);
            },
        }
    },
    methods: {
        ToggleMenu() {
            this.is_expanded = !this.is_expanded
        }
    }
}
</script>

<style lang="scss" scoped>
aside {
    display: flex;
    flex-direction: column;
    background-color: var(--dark);
    color: var(--light);
    width: calc(2rem + 32px);
    overflow: hidden;
    height: 100vh;
    padding: 1rem;
    transition: 0.2s ease-in-out;

    .flex {
        flex: 1 1 0%;
    }

    .logo {
        margin-bottom: 1rem;

        img {
            width: 2rem;
        }
    }

    .menu-toggle-wrap {
        display: flex;
        justify-content: flex-end;
        margin-bottom: 1rem;
        position: relative;
        top: 0;
        transition: 0.2s ease-in-out;

        .menu-toggle {
            transition: 0.2s ease-in-out;

            .material-icons {
                font-size: 1.5rem;
                color: var(--light);
                transition: 0.2s ease-out;
            }

            &:hover {
                .material-icons {
                    color: var(--primary);
                    transform: translateX(0.5rem);
                }
            }
        }
    }

    h3,
    .button .text {
        opacity: 0;
        transition: opacity 0.3s ease-in-out;
    }

    h3 {
        color: var(--grey);
        font-size: 0.875rem;
        margin-bottom: 0.5rem;
        text-transform: uppercase;
    }

    .menu {
        margin: 0 -1rem;

        .button {
            display: flex;
            align-items: center;
            text-decoration: none;
            transition: 0.2s ease-in-out;
            padding: 0.5rem 1rem;

            .material-icons {
                font-size: 1.5rem;
                color: var(--light);
                transition: 0.2s ease-in-out;
            }

            .text {
                color: var(--light);
                transition: 0.2s ease-in-out;
            }

            &:hover {
                background-color: var(--dark-alt);

                .material-icons,
                .text {
                    color: var(--primary);
                }
            }

            &.router-link-exact-active {
                background-color: var(--dark-alt);
                border-right: 5px solid var(--primary);

                .material-icons,
                .text {
                    color: var(--primary);
                }
            }
        }
    }

    .footer {
        opacity: 0;
        transition: opacity 0.3s ease-in-out;

        p {
            font-size: 0.875rem;
            color: var(--grey);
        }
    }

    &.is-expanded {
        width: var(--sidebar-width);

        .menu-toggle-wrap {
            margin-top: -3rem;

            .menu-toggle {
                transform: rotate(-180deg);
            }
        }

        h3,
        .button .text {
            opacity: 1;
        }

        .button {
            .material-icons {
                margin-right: 1rem;
            }
        }

        .footer {
            opacity: 0;
        }

        .logo {

            img {
                width: 2rem;
            }
        }

    }

    @media (max-width: 1024px) {
        position: absolute;
        z-index: 99;
    }
}
</style>